/* =========================================================
   Sauna Heater Size Calculator
   Steps: 1 Dimensions → 2 Insulation/Glass → 3 Indoor/Outdoor → 4 Results
   ========================================================= */

(function () {
  'use strict';

  /* ---- Heater product database ---- */
  var HEATERS = [
    /* Electric */
    { brand: 'Huum', name: 'DROP 4.5 STU', kw: 4.5,  type: 'electric', url: '/collections/huum' },
    { brand: 'Huum', name: 'DROP 6 STU',   kw: 6,    type: 'electric', url: '/collections/huum' },
    { brand: 'Huum', name: 'DROP 7.5 STU', kw: 7.5,  type: 'electric', url: '/collections/huum' },
    { brand: 'Huum', name: 'DROP 9 STU',   kw: 9,    type: 'electric', url: '/collections/huum' },
    { brand: 'Huum', name: 'HIVE 9',       kw: 9,    type: 'electric', url: '/collections/huum' },
    { brand: 'Huum', name: 'HIVE 12',      kw: 12,   type: 'electric', url: '/collections/huum' },
    { brand: 'Huum', name: 'HIVE 15',      kw: 15,   type: 'electric', url: '/collections/huum' },
    { brand: 'Harvia', name: 'KIP 60W',    kw: 6,    type: 'electric', url: '/collections/harvia' },
    { brand: 'Harvia', name: 'KIP 80W',    kw: 8,    type: 'electric', url: '/collections/harvia' },
    { brand: 'Harvia', name: 'KIP 90B',    kw: 9,    type: 'electric', url: '/collections/harvia' },
    { brand: 'Harvia', name: 'Cilindro PC90',kw: 9,  type: 'electric', url: '/collections/harvia' },
    { brand: 'Harvia', name: 'Cilindro PC115',kw:11.5,type:'electric', url: '/collections/harvia' },
    { brand: 'Saunum', name: 'AIR 7',      kw: 7,    type: 'electric', url: '/collections/saunum' },
    { brand: 'Saunum', name: 'AIR 10',     kw: 10,   type: 'electric', url: '/collections/saunum' },
    /* Wood-burning */
    { brand: 'Narvi', name: 'NC 20',       kw: 20,   type: 'wood', url: '/collections/narvi' },
    { brand: 'Narvi', name: 'Kuru 14',     kw: 14,   type: 'wood', url: '/collections/narvi' },
    { brand: 'Narvi', name: 'Kuru 20',     kw: 20,   type: 'wood', url: '/collections/narvi' },
    { brand: 'Huum', name: 'HIVE Wood 17', kw: 17,   type: 'wood', url: '/collections/huum' },
    { brand: 'Huum', name: 'HIVE Wood 23', kw: 23,   type: 'wood', url: '/collections/huum' },
  ];

  /* ---- Sizing logic ----
     Base rule: 1 kW per 45 cu ft (electric) — standard US sizing
     Glass/stone cold surfaces add equivalent volume (1 sqft glass = 7 cu ft extra)
     Outdoor/uninsulated: multiply by 1.5
  */
  var KW_PER_CUFT  = 1 / 45;
  var GLASS_FACTOR = 7;   /* extra cu ft per sq ft of glass/stone */

  function calcKw(length, width, height, glassSqft, isOutdoor) {
    var roomVolume = length * width * height;
    var glassVolume = glassSqft * GLASS_FACTOR;
    var adjustedVolume = roomVolume + glassVolume;
    if (isOutdoor) adjustedVolume *= 1.5;
    var kw = adjustedVolume * KW_PER_CUFT;
    return { adjustedVolume: Math.round(adjustedVolume), kw: Math.ceil(kw * 2) / 2 }; /* round to 0.5 */
  }

  function recommendHeaters(kwNeeded, heaterType) {
    var min = kwNeeded * 0.9;
    var max = kwNeeded * 1.6;
    var matches = HEATERS.filter(function (h) {
      var typeMatch = heaterType === 'any' || h.type === heaterType;
      return typeMatch && h.kw >= min && h.kw <= max;
    });
    /* Sort closest first */
    matches.sort(function (a, b) {
      return Math.abs(a.kw - kwNeeded) - Math.abs(b.kw - kwNeeded);
    });
    return matches.slice(0, 6);
  }

  /* ---- DOM bootstrap ---- */
  function init() {
    var calc = document.querySelector('.sauna-calc');
    if (!calc) return;

    var panels    = calc.querySelectorAll('.sauna-calc__panel');
    var dots      = calc.querySelectorAll('.sauna-calc__step-dot');
    var connectors = calc.querySelectorAll('.sauna-calc__step-connector');
    var currentStep = 0;

    function showStep(n) {
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === n);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === n);
        d.classList.toggle('is-done', i < n);
      });
      connectors.forEach(function (c, i) {
        c.classList.toggle('is-done', i < n);
      });
      currentStep = n;
    }

    /* Next buttons (steps 1–3) */
    calc.querySelectorAll('[data-calc-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fromStep = parseInt(btn.getAttribute('data-calc-next'), 10);
        if (fromStep === 0 && !validateStep0()) return;
        if (fromStep === 1 && !validateStep1()) return;
        if (fromStep === 2) buildResults();
        showStep(fromStep + 1);
        calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Back buttons */
    calc.querySelectorAll('[data-calc-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var toStep = parseInt(btn.getAttribute('data-calc-back'), 10);
        showStep(toStep);
        calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Restart */
    var restartBtn = calc.querySelector('[data-calc-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        calc.querySelectorAll('input[type="number"]').forEach(function (inp) { inp.value = ''; });
        showStep(0);
        calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---- Validation ---- */
    function validateStep0() {
      var vol = parseFloat(getVal('calc-volume'));
      var l   = parseFloat(getVal('calc-length'));
      var w   = parseFloat(getVal('calc-width'));
      var h   = parseFloat(getVal('calc-height'));
      if (vol > 0) return true;
      if (l > 0 && w > 0 && h > 0) return true;
      showError('calc-step0-error', 'Please enter your sauna dimensions or total volume.');
      return false;
    }

    function validateStep1() {
      return true; /* glass area is optional */
    }

    /* ---- Build results ---- */
    function buildResults() {
      /* gather inputs */
      var vol    = parseFloat(getVal('calc-volume'))  || 0;
      var l      = parseFloat(getVal('calc-length'))  || 0;
      var w      = parseFloat(getVal('calc-width'))   || 0;
      var h      = parseFloat(getVal('calc-height'))  || 0;
      var glass  = parseFloat(getVal('calc-glass-area'))  || 0;

      /* glass from dimensions */
      var glW    = parseFloat(getVal('calc-glass-w')) || 0;
      var glH    = parseFloat(getVal('calc-glass-h')) || 0;
      if (glW > 0 && glH > 0 && glass === 0) glass = glW * glH;

      /* indoor/outdoor */
      var placement = calc.querySelector('input[name="calc-placement"]:checked');
      var isOutdoor = placement ? placement.value === 'outdoor' : false;

      /* heater preference */
      var prefEl = calc.querySelector('#calc-heater-type');
      var pref   = prefEl ? prefEl.value : 'any';

      /* volume */
      var roomVol = vol > 0 ? vol : (l * w * h);

      var result = calcKw(
        l > 0 ? l : Math.cbrt(vol),
        l > 0 ? w : Math.cbrt(vol),
        l > 0 ? h : Math.cbrt(vol),
        glass,
        isOutdoor
      );

      /* If they gave direct volume use it */
      if (vol > 0 && !(l > 0)) {
        var glassVol = glass * GLASS_FACTOR;
        var adjVol   = vol + glassVol;
        if (isOutdoor) adjVol *= 1.5;
        result.adjustedVolume = Math.round(adjVol);
        result.kw = Math.ceil((adjVol * KW_PER_CUFT) * 2) / 2;
      }

      /* Render summary */
      var kwEl = calc.querySelector('#result-kw');
      if (kwEl) kwEl.textContent = result.kw;

      var volEl = calc.querySelector('#result-volume');
      if (volEl) volEl.textContent = result.adjustedVolume;

      var settingEl = calc.querySelector('#result-setting');
      if (settingEl) settingEl.textContent = isOutdoor ? 'Outdoor / Uninsulated (+50% load)' : 'Indoor / Insulated';

      /* Render catalog match cards */
      var products = recommendHeaters(result.kw, pref);
      var grid = calc.querySelector('#result-products');
      if (grid) {
        if (products.length === 0) {
          grid.innerHTML = '<p style="color:#6b7280;font-size:0.9375rem;">No exact matches in our database for this size — <a href="/pages/contact" style="color:#046e82;font-weight:700;">call us for a custom recommendation</a>.</p>';
        } else {
          grid.innerHTML = products.map(function (p) {
            return '<a href="' + p.url + '" class="sauna-calc__product-card">' +
              '<span class="sauna-calc__product-brand">' + p.brand + '</span>' +
              '<span class="sauna-calc__product-name">' + p.name + '</span>' +
              '<span class="sauna-calc__product-kw">' + p.kw + ' kW</span>' +
              '<span class="sauna-calc__product-link">View Collection →</span>' +
              '</a>';
          }).join('');
        }
      }

      /* Live Shopify search — fetch real products matching kW + type */
      fetchLiveProducts(result.kw, pref, isOutdoor);
    }

    /* ---- Live product search via Shopify Search API ---- */
    function fetchLiveProducts(kw, pref, isOutdoor) {
      var liveSection = calc.querySelector('#result-live-products');
      if (!liveSection) return;

      liveSection.innerHTML = '<div class="sauna-calc__live-loading"><span class="sauna-calc__spinner"></span> Searching our catalog for matching products…</div>';
      liveSection.style.display = 'block';

      /* Build search query from kW + type */
      var kwLow  = Math.max(1, kw - 1.5);
      var kwHigh = kw + 3;
      var typeTerms = [];
      if (pref === 'electric' || pref === 'any') typeTerms.push('electric sauna heater');
      if (pref === 'wood'     || pref === 'any') typeTerms.push('wood sauna stove');
      if (isOutdoor) typeTerms.push('outdoor sauna barrel');

      var query = encodeURIComponent(typeTerms[0] || 'sauna heater');
      var url = '/search/suggest.json?q=' + query + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,tag';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderLiveProducts(liveSection, items, kw, pref);
        })
        .catch(function () {
          renderLiveProducts(liveSection, [], kw, pref);
        });
    }

    function renderLiveProducts(container, items, kw, pref) {
      /* Filter out obviously irrelevant results */
      var filtered = items.filter(function (p) {
        var t = (p.title || '').toLowerCase();
        var bad = ['bucket', 'ladle', 'hat', 'towel', 'brush', 'backrest', 'thermometer', 'door handle'];
        return !bad.some(function (b) { return t.indexOf(b) !== -1; });
      });

      /* Build browse-collection fallback links based on pref */
      var collectionLinks = [
        { label: 'All Electric Sauna Heaters', url: '/collections/best-electric-sauna-heaters-for-sale' },
        { label: 'Wood-Burning Sauna Stoves',  url: '/collections/popular-wood-stoves' },
        { label: 'Complete Saunas',            url: '/collections/sauna' },
        { label: 'All Sauna Accessories',      url: '/collections/sauna-accessories' }
      ];

      if (pref === 'electric') collectionLinks = collectionLinks.filter(function(c){ return c.url !== '/collections/popular-wood-stoves'; });
      if (pref === 'wood')     collectionLinks = collectionLinks.filter(function(c){ return c.url !== '/collections/best-electric-sauna-heaters-for-sale'; });

      var html = '<div class="sauna-calc__live-header">';
      html += '<h3 class="sauna-calc__live-title">Shop Matching Products From Our Store</h3>';
      html += '<p class="sauna-calc__live-sub">Based on your ' + kw + ' kW requirement — browse the closest matches in our live catalog.</p>';
      html += '</div>';

      if (filtered.length > 0) {
        html += '<div class="sauna-calc__live-grid">';
        filtered.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
          var price = (p.price) ? ('$' + (parseInt(p.price, 10) / 100).toLocaleString()) : '';
          html += '<a href="' + p.url + '" class="sauna-calc__live-card">';
          if (img) {
            html += '<div class="sauna-calc__live-img"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>';
          } else {
            html += '<div class="sauna-calc__live-img sauna-calc__live-img--placeholder"></div>';
          }
          html += '<div class="sauna-calc__live-info">';
          html += '<span class="sauna-calc__live-name">' + p.title + '</span>';
          if (price) html += '<span class="sauna-calc__live-price">' + price + '</span>';
          html += '<span class="sauna-calc__live-cta">View Product →</span>';
          html += '</div></a>';
        });
        html += '</div>';
      }

      /* Always show browse-collection strip */
      html += '<div class="sauna-calc__live-collections">';
      html += '<p class="sauna-calc__live-collections-label">Browse by category:</p>';
      html += '<div class="sauna-calc__live-collection-links">';
      collectionLinks.forEach(function (c) {
        html += '<a href="' + c.url + '" class="sauna-calc__live-collection-btn">' + c.label + ' →</a>';
      });
      html += '</div></div>';

      container.innerHTML = html;
    }

    /* ---- Helpers ---- */
    function getVal(id) {
      var el = calc.querySelector('#' + id);
      return el ? el.value : '';
    }

    function showError(id, msg) {
      var el = calc.querySelector('#' + id);
      if (!el) return;
      el.textContent = msg;
      el.style.display = 'block';
      setTimeout(function () { el.style.display = 'none'; }, 4000);
    }

    showStep(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
